export default __webpack_public_path__ + "static/media/coimbatore_study.19ca4166.svg";